/**
 * Representation of Registered Event which allows get result of the dispatch action
 */
class RegisteredGlobalEvent<T, U> {
  constructor(
    private successName: string,
    private failureName: string,
    private eventObject: Document | HTMLElement = window.document
  ) {}

  /**
   * Subscribe to result success/fail
   */
  subscribe(resolve: (data: T) => void, reject: (data: U) => void): void {
    const successCallback = ($event: CustomEvent) => {
      resolve($event.detail);
      this.eventObject.removeEventListener(this.successName, successCallback as EventListener);
      this.eventObject.removeEventListener(this.failureName, errorCallback as EventListener);
    };
    const errorCallback = ($event: CustomEvent) => {
      reject($event.detail);
      this.eventObject.removeEventListener(this.failureName, errorCallback as EventListener);
      this.eventObject.removeEventListener(this.successName, successCallback as EventListener);
    };

    this.eventObject.addEventListener(this.successName, successCallback as EventListener);
    this.eventObject.addEventListener(this.failureName, errorCallback as EventListener);
  }
}

export default RegisteredGlobalEvent;
